export enum PolicySearchOwnerType {
    Individual = "individual",
    Company = "company",
}

export enum PolicySearchResultPartyType {
    Agent = "agent",
    Insured = "insured",
    Owner = "owner",
}

export enum PolicySearchFormFields {
    PolicyNumber = "policyNumber",
    ApplicationNumber = "applicationNumber",
    InsuredLastName = "insuredLastName",
    InsuredFirstName = "insuredFirstName",
    InsuredDateOfBirth = "insuredDateOfBirth",
    InsuredPhone = "insuredPhone",
    InsuredIDNumber = "insuredIDNumber",
    InsuredCIFNumber = "insuredCIFNumber",
    OwnerLastName = "ownerLastName",
    OwnerFirstName = "ownerFirstName",
    OwnerCompanyName = "ownerCompanyName",
    OwnerDateOfBirth = "ownerDateOfBirth",
    OwnerPhone = "ownerPhone",
    OwnerIDNumber = "ownerIDNumber",
    OwnerCIFNumber = "ownerCIFNumber",
    TypeOfOwner = "typeOfOwner",
    TypeOfBusiness = "productType",
    ProductShortName = "productShortName",
    AgentID = "agentID",
    AgentContractNumber = "agentContractNumber",
    StartDate = "startDate",
    EndDate = "endDate",
    PeriodType = "periodType",
    PolicyNumberOnly = "policyNumberOnly",
    PFANumber = "PFANumber",
}

export enum PolicyAdditionalInformationType {
    Date = "date",
    Currency = "currency",
    String = "string",
}

export enum PolicySearchBusinessType {
    All = "All",
    Life = "PRT_LIFE",
    Annuity = "PRT_ANNUITY",
    Fda = "PRT_FDA",
}

export enum PolicySearchConstants {
    SuggestionValidLength = 3,
    SuggestionMaxItems = 10,
}

export const PolicySearchDateConstants = {
    MinAllowedDate: "1900-01-01",
    MinAllowedBirthDate: "1900-01-01",
};

export const PolicySearchResultConstants = {
    MaxAdditionalInfoDesktop: 5,
    MaxAdditionalInfoMobile: 3,
};

export enum PolicyPartyType {
    None = "none",
    CompanyOwner = "companyOwner",
    IndividualOwner = "individualOwner",
    Insured = "insured",
}

export enum PeriodType {
    Custom = "CUSTOM",
    SpecificDate = "SPECIFIC_DATE",
    None = "NONE",
}
